import React, { Component } from "react";
import PageHelmet from "../component/common/Helmet";
import {FaTwitter ,FaInstagram ,FaFacebookF , FaLinkedinIn} from "react-icons/fa";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Header from "../component/header/Header";
import Footer from "../component/footer/Footer";

const SocialShare = [
    {Social: <FaFacebookF /> , link: 'https://www.facebook.com/'},
    {Social: <FaLinkedinIn /> , link: 'https://www.linkedin.com/'},
    {Social: <FaInstagram /> , link: 'https://www.instagram.com/'},
    {Social: <FaTwitter /> , link: 'https://twitter.com/'},
]

class InfluencersDetails extends Component{
    constructor () {
        super()
        this.state = {
          isOpen: false
        }
        this.openModal = this.openModal.bind(this)
    }
    openModal () {
        this.setState({isOpen: true})
    }
    render(){
        return(
            <React.Fragment>
                <PageHelmet pageTitle='Go2Market' />

                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.png" />
                
                {/* Start Breadcrump Area */}
                <div className="rn-page-title-area pt--120 pb--190 bg_image bg_image--4"  data-black-overlay="7">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="rn-page-title text-center pt--100">
                                    <h2 className="title theme-gradient">CUTRELAND</h2>
                                    <p>Red de servidores personalizados para Influencers</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Breadcrump Area */}

                {/* Start Portfolio Details */}
                <div className="rn-portfolio-details ptb--120 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="portfolio-details">
                                    <div className="inner">
                                        <h2>Cutreland</h2>
                                        <p className="subtitle">Red de servidores personalizados para Influencers</p>
                                        <p>Descubre nuestra impresionante red de servidores personalizados para
                                            influencers, que fueron diseñados específicamente para potenciar la
                                            experiencia de juego de destacados influencers como Ibai, Illojuan, Elmillor
                                            y Elrichmc, entre otros. Nuestros servidores contaban con modificaciones en
                                            el juego desarrolladas en Java 8, lo que garantizaba una experiencia única y
                                            emocionante para todos los jugadores.</p>
                                        <p>En el año 2020, el renombrado streamer Ibai Llanos solicitó personalmente
                                            estos servidores, lo que demostró la calidad y el rendimiento inigualables
                                            que ofrecemos. Además, Movistar eSports cubrió nuestras novedades,
                                            destacando a los participantes y el emocionante comienzo que nuestros
                                            servidores brindaron en el mundo del gaming:</p>
                                        <ul>
                                            <li>- <a
                                                href="https://esports.as.com/bonus/participantes-Cutreland_3_1362493739.html">Participantes</a>
                                            </li>
                                            <li>- <a
                                                href="https://esports.as.com/bonus/comienzo-Cutreland-desvela-prometedora-muchas_0_1362463742.html">Comienzo</a>
                                            </li>
                                        </ul>
                                        <p>Aquí puedes ver algunos de los emocionantes videos subidos por
                                            influencers:</p>
                                        <iframe width="560" height="315" src="https://www.youtube.com/embed/YC0IgL78H3w"
                                                title="YouTube video player" frameBorder="0"
                                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                allowFullScreen></iframe>
                                        <iframe width="560" height="315" src="https://www.youtube.com/embed/zqMyMmCLisc"
                                                title="YouTube video player" frameBorder="0"
                                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                allowFullScreen></iframe>
                                        <iframe width="560" height="315" src="https://www.youtube.com/embed/YyVspaggN7w"
                                                title="YouTube video player" frameBorder="0"
                                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                allowFullScreen></iframe>
                                        <p></p>
                                        <div className="portfolio-view-list d-flex flex-wrap">
                                            <div className="port-view">
                                                <span>Desarrollo plugins</span>
                                                <h4>Java</h4>
                                            </div>
                                            <div className="port-view">
                                                <span>SO Servidor</span>
                                                <h4>Debian 9</h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                {/* End Portfolio Details */}

                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}
                
                <Footer />  


            </React.Fragment>
        )
    }
}
export default InfluencersDetails;
